import { render, staticRenderFns } from "./ProcessVariables.vue?vue&type=template&id=4df8b5c4&scoped=true"
import script from "./ProcessVariables.vue?vue&type=script&lang=js"
export * from "./ProcessVariables.vue?vue&type=script&lang=js"
import style0 from "./ProcessVariables.vue?vue&type=style&index=0&id=4df8b5c4&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8b5c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VFlex,VLayout})
